<div class="container-fluid navBarInvoice">
  <app-header-form [title]="title" [panelOpenState]="panelOpenState" [canShowClearFilter]="true" [canShowPanelFilter]="true" [canExportExcel]="true" (onClearFilterEvent)="onClearFilters()"
    (onPanelOpenStateEvent)="onShowFilter($event)" (onExportAsExcelEvent)="exportAsExcel()">
  </app-header-form>
</div>

<hr>

<div class="container-fluid search-container">
  <div style="position: relative" class="search-panel advancedFilter dropDownStyle" *ngIf="panelOpenState">
    <mat-form-field appearance="outline" fxFlex="25" fxFlex.gt-sm="25" floatLabel="always">
      <mat-label>Mise en litige</mat-label>
      <input matInput type="text" hidden>
      <ng-multiselect-dropdown placeholder="" [settings]="dropdownSettings" [data]="dropdownListComplaint" (onDeSelect)="filterData(true)" (onSelect)="filterData(true)" placeholder='Sélectionner...'
        (onDeSelectAll)="onSelectAll($event, 'IsComplaint')" (onSelectAll)="onSelectAll($event,'IsComplaint')" [(ngModel)]="selectedItemsComplaint">
      </ng-multiselect-dropdown>
    </mat-form-field>
    <br>
  </div>
</div>

<app-invoice-list [(data)]="data" [tableRowsActions]="tableActions" [tableMassActions]="tableMassActions" [onFiltersCleared]="onFiltersCleared" [onExportExcelCaller]="onExportExcelCaller"
  [exportFileName]="exportFileName" [tableIndications]="tableIndications" [canDownload]="false" [configKey]="configKey" ngDefaultControl [showClearFilterButton]="true">
</app-invoice-list>
